import { useEffect, useState } from 'react';
import { Box, Container, Heading } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import PublicContent from '@/components/content-list/public-content';
import WorkspaceShell from '@/components/layout/workspace-shell';
import { baseApi } from '@/utils/api';

type Meta = {
  workspaceName?: string;
  workspaceLogo?: string;
  workspaceBannerImage?: string;
  contentTypeName?: string;
};

export default function PublicContentList() {
  const { referenceId } = useParams<{ referenceId: string }>();
  const [meta, setMeta] = useState<Meta>({});

  useEffect(() => {
    if (!referenceId) return;
    let cancelled = false;
    (async () => {
      try {
        const response = await baseApi.post('/public/contents/search', {
          content_type_reference_id: referenceId,
          q: '',
          page: 1,
          page_size: 1,
          sort: ['created_at:desc'],
          filters: [{ key: 'status', val: 'published' }],
          select_list_filters: [],
          facet_fields: [],
        });
        if (cancelled) return;
        const data = response.data?.data;
        setMeta({
          workspaceName: data?.Workspace?.name,
          workspaceLogo: data?.Workspace?.logo,
          workspaceBannerImage: data?.Workspace?.banner_image,
          contentTypeName: data?.ContentType?.name,
        });
      } catch {
        // Workspace branding is non-critical chrome — shell falls back to generic on failure.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [referenceId]);

  return (
    <WorkspaceShell
      workspaceName={meta.workspaceName}
      workspaceLogo={meta.workspaceLogo}
      workspaceBannerImage={meta.workspaceBannerImage}
    >
      <Container maxW='5xl' px={{ base: 4, md: 6 }} mt={{ base: -6, md: -10 }} pb={10}>
        <Box bg='white' borderRadius='2xl' shadow={{ base: 'sm', md: 'lg' }} p={{ base: 5, md: 8 }}>
          {meta.contentTypeName && (
            <Heading
              as='h1'
              fontSize={{ base: '2xl', md: '3xl' }}
              fontWeight='bold'
              letterSpacing='-0.01em'
              mb={5}
            >
              {meta.contentTypeName}
            </Heading>
          )}
          {referenceId && <PublicContent referenceId={referenceId} hasHeader={false} />}
        </Box>
      </Container>
    </WorkspaceShell>
  );
}
